import React from "react";
import { Box, Typography } from "@mui/material";

const MatchedUser = ({ user }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: 2,
        border: "1px solid #ccc",
        borderRadius: 2,
        width: "100%",
      }}
    >
      <Typography variant="h6" gutterBottom>
        {user.name}
      </Typography>
      <Typography variant="body2" color="textSecondary">
        {user.description}
      </Typography>
      <Typography variant="body2" color="textSecondary">
        DOB: {user.dob}
      </Typography>
      <Typography variant="body2" color="textSecondary">
        Mobile: {user.mobile}
      </Typography>
      <Typography variant="body2" color="textSecondary">
        Matched Criteria: {user.matched}
      </Typography>
      <Typography variant="body2" color="textSecondary">
        Horoscope: {user.horoscope}
      </Typography>
      <Typography variant="body2" color="textSecondary">
        Age: {user.age} years
      </Typography>
    </Box>
  );
};
export default MatchedUser;
